import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationOtherSettingId {
  ONLINE_RESERVATION = 1,
  WITHOUT_SENT_VOUCHER = 2,
  NON_REFUNDABLE_RATE = 3,
}

export class ReservationOtherSetting extends Codebook<ReservationOtherSettingId> {
  static readonly ONLINE_RESERVATION = new ReservationOtherSetting(
    ReservationOtherSettingId.ONLINE_RESERVATION,
    () => $t('Online reservation'),
  )
  static readonly WITHOUT_SENT_VOUCHER = new ReservationOtherSetting(
    ReservationOtherSettingId.WITHOUT_SENT_VOUCHER,
    () => $t('Without sent voucher '),
  )
  static readonly NON_REFUNDABLE_RATE = new ReservationOtherSetting(
    ReservationOtherSettingId.NON_REFUNDABLE_RATE,
    () => $t('Non-refundable rate'),
  )

  private constructor(
    public readonly id: ReservationOtherSettingId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
